var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSleeperSmall = function SvgSleeperSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "sleeperSmall_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1A1A1A",
    mask: "url(#sleeperSmall_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.667 8.667a.333.333 0 0 1-.333-.333V6.001q0-.267.192-.467a.63.63 0 0 1 .475-.2h5.99q.833 0 1.417.583.583.584.583 1.417v1c0 .184-.15.333-.333.333zM3.234 8.075q-.517 0-.875-.367a1.2 1.2 0 0 1-.358-.866q0-.517.358-.876a1.2 1.2 0 0 1 .875-.358q.5 0 .867.358.366.36.366.876 0 .5-.366.866a1.19 1.19 0 0 1-.867.367M4.758 9.667h9.41q.216 0 .358.142a.49.49 0 0 1 .141.358.5.5 0 0 1-.098.31.487.487 0 0 1-.402.19H2.04c-.373 0-.706-.333-.706-.666v-.334c0-.368.338-.5.706-.5h2.052c.368 0 .666.132.666.5"
  }))));
};
export default SvgSleeperSmall;